import { render } from "./GraficoStatusProjetosPizza.vue?vue&type=template&id=68688774&scoped=true"
import script from "./GraficoStatusProjetosPizza.vue?vue&type=script&lang=js"
export * from "./GraficoStatusProjetosPizza.vue?vue&type=script&lang=js"

import "./GraficoStatusProjetosPizza.vue?vue&type=style&index=0&id=68688774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68688774"]])

export default __exports__